import React from 'react';

export type FormStatus = 'idle' | 'sending' | 'sent' | 'error';

interface FormShellProps {
  eyebrow: string;
  status: FormStatus;
  successTitle?: string;
  successBody?: string;
  errorMessage?: string;
  className?: string;
  children: React.ReactNode;
}

export function FormShell({
  eyebrow,
  status,
  successTitle = 'MESSAGE RECEIVED',
  successBody = "We'll be in touch shortly.",
  errorMessage = 'Something broke. Call (407) 461-6039.',
  className = '',
  children,
}: FormShellProps) {
  return (
    <div
      className={`bg-charcoal-deep border border-thunder/30 p-8 lg:p-10 backdrop-blur-sm ${className}`}
    >
      <div className="font-display text-electric tracking-[0.3em] text-xs mb-8">{eyebrow}</div>

      {status === 'sent' ? (
        <div className="text-center py-12">
          <div className="font-display text-thunder text-xl tracking-wider mb-3">
            ✓ {successTitle}
          </div>
          <p className="text-white/60">{successBody}</p>
        </div>
      ) : (
        <>
          {children}
          {status === 'error' && (
            <p className="text-red-400 text-sm text-center mt-4">{errorMessage}</p>
          )}
        </>
      )}
    </div>
  );
}
